import React, { useEffect, useRef, useState } from "react";
import loaderVideo from "../assets/load.mp4";
import "./LogoLoader.css";

const LogoLoader = () => {
  const videoRef = useRef(null);
  const [showSoundPrompt, setShowSoundPrompt] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const video = videoRef.current;
    if (!video) return undefined;

    const startPlayback = async () => {
      video.muted = false;
      try {
        await video.play();
        if (isMounted) {
          setShowSoundPrompt(false);
        }
      } catch {
        // Fallback: muted autoplay works on most browsers without user interaction.
        video.muted = true;
        try {
          await video.play();
        } catch {
          // If this also fails, the browser is blocking autoplay entirely.
        }
        if (isMounted) {
          setShowSoundPrompt(true);
        }
      }
    };

    startPlayback();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleEnableSound = async () => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = false;
    try {
      await video.play();
      setShowSoundPrompt(false);
    } catch {
      video.muted = true;
      setShowSoundPrompt(true);
    }
  };

  return (
    <div className="logo-loader" role="status" aria-live="polite" aria-label="Loading">
      <video
        ref={videoRef}
        className="logo-loader-video"
        autoPlay
        muted
        playsInline
        preload="auto"
        aria-hidden="true"
      >
        <source src={loaderVideo} type="video/mp4" />
      </video>
      {showSoundPrompt && (
        <button type="button" className="logo-loader-sound-btn" onClick={handleEnableSound}>
          Tap for sound
        </button>
      )}
    </div>
  );
};

export default LogoLoader;
